/* eslint-disable no-console */
import { LoadingOutlined } from '@ant-design/icons';
import { Drawer, Spin } from 'antd';
import { useState } from 'react';
import { useActiveSchoolId } from '../../../../hooks/useActiveSchoolId';
import { useHasClientCode, useSocketStore } from '../../../../stores/SocketStore';
import { trpc } from '../../../../utils/trcp';
import { createLoadingNotification } from '../../../Notification';
import StudentPass from '../../../StudentPass/StudentPass';
import { Card, CardButton } from './styles';

type Props = {
	studentId: string;
};

export const RecordTab = ({ studentId }: Props) => {
	const { activeSchoolId } = useActiveSchoolId();
	const getNewClientCode = useSocketStore(s => s.getNewClientCode);
	const [activeClientCode, setActiveClientCode] = useState<string | undefined>();
	const hasClientCode = useHasClientCode(activeClientCode ?? '');
	//
	const [isPassOpen, setIsPassOpen] = useState(false);

	const exportReportClassBook = trpc.student.exportReportClassBook.useMutation();
	const exportReportVehicleDrivingTraining = trpc.student.exportReportVehicleDrivingTraining.useMutation();

	const onExportEvidence = async () => {
		const clientCode = getNewClientCode();
		setActiveClientCode(clientCode);
		createLoadingNotification({
			message: 'Generuji evidenci o výcviku v řízení vozidla',
			description: 'Váš PDF export se připravuje, prosím čekejte...',
			clientCode,
		});
		await exportReportVehicleDrivingTraining.mutateAsync({
			schoolId: activeSchoolId,
			studentId,
			clientCode,
		});
	};

	const exportClassBook = async () => {
		const clientCode = getNewClientCode();
		setActiveClientCode(clientCode);
		createLoadingNotification({
			message: 'Generuji třídní knihu',
			description: 'Váš PDF export se připravuje, prosím čekejte...',
			clientCode,
		});
		await exportReportClassBook.mutateAsync({
			schoolId: activeSchoolId,
			studentId,
			clientCode,
		});
	};
	return (
		<>
			<Drawer placement="right" onClose={() => setIsPassOpen(false)} open={isPassOpen} size="default">
				{isPassOpen && <StudentPass studentId={studentId} type="app" />}
			</Drawer>
			<Card>
				<CardButton type="button" onClick={onExportEvidence} disabled={hasClientCode}>
					{hasClientCode && <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />}
					Evidence o výcviku v řízení vozidla export do PDF
				</CardButton>
				<CardButton type="button" onClick={exportClassBook} disabled={hasClientCode}>
					{hasClientCode && <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />}
					Třídní kniha export do PDF
				</CardButton>
				<CardButton
					type="button"
					onClick={() => {
						setIsPassOpen(true);
					}}
				>
					Průkaz žadatele o řidičské oprávnění
				</CardButton>
			</Card>
		</>
	);
};
